import { getEnvironmentUrlApiV2 } from './getEnvironmentUrlApiV2';

type Format = 'H264Main' | 'HLS';

type H264Video = { H264Main: string };
type HLSVideo = H264Video & { HLS: string };

type VideoUrls = H264Video | HLSVideo;

type ThumbnailUrls = {
  still?: string;
  animated?: string;
};

type VideoDetail = {
  id: string;
  copiedFromId: string;
  status: '1' | '0';
  user_id: string;
  name: string;
  alt_text: string;
  should_show_hls_format: boolean;
  video_urls: VideoUrls;
  animated: '1' | '0';
  thumb_id: string;
  thumb_url: string;
  animated_thumb_url: string;
  available_thumbnail_urls: ThumbnailUrls;
  use_animated_thumbnail: boolean;
  useAnimatedGif: boolean;
  true_thumbnail_url: string;
  trueThumbnailUrl: string;
  thumb_url_orig: string;
  thumb_switch_url: string;
  using_custom_thumb: '0' | '1';
  no_logo: '0' | '1';
  short_url: string;
  play_button_pos: string;
  height: string | number;
  width: string | number;
  duration: string | number;
  encoder_key: string;
  video_input_method: string;
  upload_date: string;
  updated_date: string;
  available_formats: Format[];
  original_video_url: string;
  cdn_video_id: string;
  heatmap_do_not_proc: '0' | '1';
  hosting_partner: string;
  userFirstName: string;
  userLastName: string;
  userEmailAddress: string;
  clientName: string;
  full_url: string;
  ctaTitle?: string;
  ctaLink?: string;
};

export async function getVideoDetails(
  authToken: string,
  environment: Parameters<typeof getEnvironmentUrlApiV2>[0],
  videoId: string,
): Promise<VideoDetail | null> {
  const response = await fetch(`${getEnvironmentUrlApiV2(environment)}videos/${videoId}`, {
    method: 'GET',
    headers: new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${authToken}`,
    }),
  });

  if (response.ok) {
    return response.json() as unknown as VideoDetail;
  }

  return null;
}

export function isHLSAvailable(videoUrls: VideoUrls): videoUrls is HLSVideo {
  return Boolean('HLS' in videoUrls && videoUrls.HLS);
}
